var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";

function IllustrationYearBuilt(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M44 6H4v38h40V6z"
  }), React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M12 4v4M36 4v4"
  }), React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M27.32 21.06L14 34M22.08 14.8l7.06 7.08"
  }), React.createElement("path", {
    className: "fill",
    d: "M33.38 20.471l-5.657-5.656a2 2 0 00-2.829 0l-1.414 1.414a2 2 0 000 2.828l5.657 5.657a2 2 0 002.828 0L33.38 23.3a2 2 0 000-2.829z"
  }));
}

export default IllustrationYearBuilt;